import React from 'react'
import { ChevronDown } from 'lucide-react'

const TotalPageNumber = ({ 
  totalPages = 10,
  itemsPerPage = 20,
  onItemsPerPageChange 
}) => {
  return (
    <div className="relative bg-gray-50 rounded-md border border-gray-200 px-2 sm:px-3 py-1 sm:py-1.5 w-full sm:w-auto">
      <select
        value={itemsPerPage}
        onChange={(e) => onItemsPerPageChange(parseInt(e.target.value))}
        className="appearance-none bg-transparent border-none px-0 py-0 pr-6 sm:pr-8 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
      <ChevronDown className="absolute right-1.5 sm:right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 sm:w-4 sm:h-4 text-gray-400 pointer-events-none" />
    </div>
  )
}

export default TotalPageNumber
